import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_2 = {
  key: 1,
  class: "text-muted"
}

import {
    getSelectedVirtualOperator,
    VirtualOperatorConfigInterface
} from "~/cabinet/vue/client/online/config/operators/virtual/Interface";
import {computed} from "vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "VirtualOperatorPreview"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    virtualOperators: {},
    operatorId: {}
  },
  setup(__props: any) {

let props = __props;

let selectedOperator = computed(() => getSelectedVirtualOperator(props.virtualOperators, props.operatorId));


return (_ctx: any,_cache: any) => {
  return (__props.operatorId)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(selectedOperator))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(selectedOperator).descr) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-muted" }, " (виртуальный) ", -1))
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, " Удалённый виртуальный оператор "))
      ], 64))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, " Не выбран "))
}
}

})